import React from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Loader2, AlertTriangle, Sparkles, Clock } from "lucide-react";
import { API } from "@/lib/api";
import { AIPanel, DataPanel } from "@/components/AIAnalysis";

const LOGO = process.env.PUBLIC_URL + "/logo-central.png";

export default function SharePage() {
  const { token } = useParams();
  const [state, setState] = React.useState({ status: "loading" });

  React.useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/share/${token}`)
      .then((r) => !cancelled && setState({ status: "done", data: r.data }))
      .catch((e) =>
        !cancelled &&
        setState({ status: "error", detail: e?.response?.data?.detail || "Enlace no válido" }),
      );
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (state.status === "loading") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-slate-500 bg-[#f4f5f7]">
        <Loader2 className="w-10 h-10 text-[#E2333F] animate-spin" />
        <div className="font-display font-bold text-lg text-slate-700">Cargando análisis compartido…</div>
      </div>
    );
  }

  if (state.status === "error") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-center px-6 bg-[#f4f5f7]">
        <AlertTriangle className="w-10 h-10 text-red-500" />
        <div className="font-display font-black text-2xl text-slate-800">Enlace no disponible</div>
        <div className="text-slate-500 max-w-md">{state.detail}</div>
        <div className="text-xs text-slate-400 mt-2">Los enlaces compartidos tienen una vigencia de 24 horas.</div>
      </div>
    );
  }

  const { data } = state;
  const levelLabel = { grupo: "Grupo", division: "División", zona: "Zona", regional: "Regional", empresa: "Empresa" };
  const expiresTxt = new Date(data.expires_at).toLocaleString("es-MX", {
    day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
  });

  return (
    <div className="min-h-screen bg-[#f4f5f7]">
      <header className="h-16 bg-[#0F172A] text-white flex items-center justify-between px-6 sticky top-0 z-40">
        <div className="flex items-center gap-3">
          <img src={LOGO} alt="ZAE" className="h-9 w-9 rounded-md object-contain bg-black" />
          <div>
            <div className="text-[11px] uppercase tracking-widest text-white/60 font-bold leading-none flex items-center gap-1">
              <Sparkles className="w-3.5 h-3.5 text-amber-400" /> Análisis IA compartido
            </div>
            <div className="font-display font-black text-lg leading-tight">
              {levelLabel[data.level]} · {data.name}
            </div>
          </div>
        </div>
        <div className="hidden sm:flex items-center gap-1.5 text-[11px] text-amber-400 font-semibold">
          <Clock className="w-3.5 h-3.5" /> Válido hasta {expiresTxt}
        </div>
      </header>

      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-[1fr_420px]">
        <div className="bg-white">
          <AIPanel context={data.context} analysis={data.analysis} />
        </div>
        <div className="hidden lg:block">
          <DataPanel context={data.context} />
        </div>
      </div>

      <footer className="text-center text-xs text-slate-400 py-6">
        ZAE Ejecutivo · Grupo Tomza · Periodo {data.period} · Vista de solo lectura
      </footer>
    </div>
  );
}
